var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mall-category-page" },
    [
      _c("div", { staticClass: "hero" }, [
        _c("div", [
          _c("span", [_vm._v("MALL CATEGORY")]),
          _c("h2", [_vm._v("分类展示")]),
          _c("p", [
            _vm._v(
              "已启用 " +
                _vm._s(_vm.guide.enabledCategories || 0) +
                "/" +
                _vm._s(_vm.guide.totalCategories || 0) +
                " 个商城分类。"
            ),
          ]),
        ]),
      ]),
      _c(
        "el-card",
        {
          attrs: { shadow: "never", "body-style": { padding: "0 20px 20px" } },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.guide.items || [], size: "mini" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "sort", label: "序号", width: "70" },
              }),
              _c("el-table-column", {
                attrs: { prop: "icon", label: "图标", width: "90" },
              }),
              _c("el-table-column", {
                attrs: { prop: "title", label: "分类", "min-width": "140" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "description",
                  label: "说明",
                  "min-width": "220",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态", width: "100" },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.status === "pending" || row.status === "off"
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.runAction(row.id, "enable")
                                  },
                                },
                              },
                              [_vm._v("启用")]
                            )
                          : _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.runAction(row.id, "disable")
                                  },
                                },
                              },
                              [_vm._v("停用")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }